// extracted by mini-css-extract-plugin
export default {"notes-pair":"NotesPair_notes-pair__j-RwC"};